<template lang="pug">
#home
  vheader
  mobile-nav
  intro
  footer-user
  vfooter
</template>

<script>
import Vheader from '../components/Vheader.vue'
import MobileNav from '../components/mobile/Nav.vue'
import Intro from '../components/Intro.vue'
import FooterUser from '../components/FooterUser.vue'
import Vfooter from '../components/Vfooter.vue'

export default {
  name: 'app',
  components: {
    Vheader,
    Intro,
    FooterUser,
    Vfooter,
    MobileNav
  }
}
</script>

<style lang="stylus">
#home
  width 100%
  background #fff
  .continued
    .container
      padding-top 90px
      padding-bottom 50px
</style>



// WEBPACK FOOTER //
// Intro.vue?79512b57